import React from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { BaseSSOIntegrationConnector } from './BaseSSOIntegrationConnector'

interface CustomDomainSSOIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
  postConnectRedirectPath?: string
}

export const CustomDomainSSOIntegrationConnector: React.FC<CustomDomainSSOIntegrationConnectorProps> = ({
  serviceId,
  startConnect,
  onConnected,
  postConnectRedirectPath,
}) => {
  const stateStep = `${serviceId.toLowerCase()}_discovery_step`
  return (
    <BaseSSOIntegrationConnector
      serviceId={serviceId}
      startConnect={startConnect}
      onConnected={onConnected}
      stateStep={stateStep}
      postConnectRedirectPath={postConnectRedirectPath}
    />
  )
}
